module.exports = __webpack_public_path__ + "img/never-opened.png";